module.exports = __webpack_public_path__ + "static/media/address-book.0c2f3577.svg";